// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import {
  NewPlanningProduct,
  type PlanningProduct,
  type PlanningProductWireFormat,
} from '../PlanningProduct/PlanningProduct';

export class PlanningNode {
  readonly id: string;
  readonly plantId: string;
  readonly kind: Enums.PlanningNodeKind;
  readonly companyId: string | null;
  readonly projectId: string | null;
  readonly name: string;
  readonly description: string | null;
  readonly isTopDown: boolean;
  readonly products: PlanningProduct[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.kind = data.kind === undefined ? Enums.PlanningNodeKind.Customer : data.kind;
    this.companyId = data.companyId === undefined ? null : data.companyId;
    this.projectId = data.projectId === undefined ? null : data.projectId;
    this.name = data.name === undefined ? '' : data.name;
    this.description = data.description === undefined ? null : data.description;
    this.isTopDown = data.isTopDown === undefined ? false : data.isTopDown;
    this.products = (data.products ?? []).map((products: any) => NewPlanningProduct(products));
  }

  static zero(): PlanningNode {
    const zeroValues: ExcludeMethodsDeep<PlanningNode> = {
      id: NIL_UUID,
      plantId: NIL_UUID,
      kind: Enums.PlanningNodeKind.Customer,
      companyId: null,
      projectId: null,
      name: '',
      description: null,
      isTopDown: false,
      products: [],
    };
    return new PlanningNode(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlanningNodeWireFormat = {
  id: string;
  plantId: string;
  kind: string;
  companyId: string | null;
  projectId: string | null;
  name: string;
  description: string | null;
  isTopDown: boolean;
  products: PlanningProductWireFormat[];
};

type NewPlanningNodeProps = PartialDeep<PlanningNode, { recurseIntoArrays: true }>;
export const NewPlanningNode: (props: NewPlanningNodeProps) => PlanningNode = (props) =>
  new PlanningNode(props);

type NewPlanningNodeFromWireFormatProps = PartialDeep<
  PlanningNodeWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlanningNodeFromWireFormat: (
  props: NewPlanningNodeFromWireFormatProps,
) => PlanningNode = (props) => new PlanningNode(props);
